/** @type {import('node_modules/vue-router/types/index').RouteConfig[]} */
import i18n from '@/i18n/i18n'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

import { getHelpCenterUrl } from '@/services/help-center-url.service'

import store from '@/store/store.js'

export const SETTINGS_NOTIFY_TRACKING_ROUTE = 'notify'
export const SETTINGS_NOTIFY_TRACKING_MESSAGES_ROUTE = 'notify.tracking-messages'
export const SETTINGS_NOTIFY_TRACKING_MESSAGES_EMAIL_ROUTE = 'notify.tracking-messages.email'
export const SETTINGS_NOTIFY_TRACKING_MESSAGES_SMS_ROUTE = 'notify.tracking-messages.sms'
export const SETTINGS_NOTIFY_TRACKING_MESSAGES_WHATSAPP_ROUTE = 'notify.tracking-messages.whatsapp'
export const SETTINGS_NOTIFY_TRACKING_PAGE_ROUTE = 'notify.tracking-page'
export const SETTINGS_NOTIFY_TRACKING_WIDGET_ROUTE = 'notify.tracking-portal'

export const SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_ROUTE = 'notify.tracking-messages-v2'
export const SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_OVERVIEW_ROUTE = 'notify.tracking-messages-v2.overview'
export const SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_SETTINGS_ROUTE = 'notify.tracking-messages-v2.settings'
export const SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_EMAIL_ROUTE = 'notify.tracking-messages-v2.email'
export const SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_SMS_ROUTE = 'notify.tracking-messages-v2.sms'

export const btnHelpCenter = {
  id: 'open-help-center',
  title: () => i18n.t('Help center'),
  name: 'Help center button',
  href: getHelpCenterUrl('sms', 'tracking'),
  newTab: true,
  mode: 'borderless',
  icon: faInfoCircle,
  align: 'right',
}

export const btnHelpCenterWhatsApp = {
  id: 'open-help-center',
  title: () => i18n.t('Help center'),
  name: 'Help center button',
  href: getHelpCenterUrl('whatsapp', 'tracking'),
  newTab: true,
  mode: 'borderless',
  icon: faInfoCircle,
  align: 'right',
}

export const btnHelpCenterMessagesV2 = {
  id: 'open-help-center',
  title: () => i18n.t('Help center'),
  name: 'Help center button',
  href: getHelpCenterUrl('messages_v2', 'tracking'),
  newTab: true,
  mode: 'borderless',
  icon: faInfoCircle,
  align: 'right',
}

export default {
  name: SETTINGS_NOTIFY_TRACKING_ROUTE,
  path: 'track-and-trace',
  redirect: { name: SETTINGS_NOTIFY_TRACKING_MESSAGES_ROUTE },
  component: () => import('@/app/settings/ParentRoutePlaceholder.vue'),
  children: [
    {
      name: SETTINGS_NOTIFY_TRACKING_MESSAGES_ROUTE,
      path: 'messages',
      redirect: { name: SETTINGS_NOTIFY_TRACKING_MESSAGES_EMAIL_ROUTE },
      component: () => import('@/app/settings/notify/views/TrackingMessages.vue'),
      meta: {
        pageTitle: () => i18n.t('Tracking messages'),
        permissions: ['configure_tracking'],
      },
      children: [
        {
          name: SETTINGS_NOTIFY_TRACKING_MESSAGES_EMAIL_ROUTE,
          path: 'email',
          component: () => import('@/app/settings/notify/views/TrackingEmail.vue'),
          meta: {
            pageTitle: () => i18n.t('Tracking messages'),
            permissions: ['configure_tracking'],
          },
        },
        {
          name: SETTINGS_NOTIFY_TRACKING_MESSAGES_SMS_ROUTE,
          path: 'sms',
          component: () => import('@/app/settings/notify/views/TrackingSMS.vue'),
          meta: {
            pageTitle: () => i18n.t('Tracking messages'),
            permissions: ['configure_tracking'],
            buttons: [btnHelpCenter],
          },
        },
        {
          name: SETTINGS_NOTIFY_TRACKING_MESSAGES_WHATSAPP_ROUTE,
          path: 'whatsapp',
          component: () => import('@/app/settings/notify/views/TrackingWhatsApp.vue'),
          meta: {
            pageTitle: () => i18n.t('Tracking messages'),
            permissions: ['configure_tracking'],
            buttons: [btnHelpCenterWhatsApp],
          },
        },
      ],
    },
    {
      name: SETTINGS_NOTIFY_TRACKING_PAGE_ROUTE,
      path: 'page',
      component: () => import('@/app/settings/notify/views/TrackingPage.vue'),
      meta: {
        pageTitle: () => i18n.t('Tracking page'),
        permissions: ['configure_tracking'],
      },
    },
    {
      name: SETTINGS_NOTIFY_TRACKING_WIDGET_ROUTE,
      path: 'widget',
      component: () => import('@/app/settings/notify/views/TrackingWidget.vue'),
      meta: {
        pageTitle: () => i18n.t('Tracking widget'),
        permissions: ['configure_tracking'],
      },
    },
    // v2
    {
      name: SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_ROUTE,
      path: 'messages-v2',
      component: () => import('@/app/settings/notify/views/messages-v2/TrackingMessagesWrapper.vue'),
      redirect: { name: SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_OVERVIEW_ROUTE },
      beforeEnter: (_to, _from, next) => {
        if (store.getters.user?.is_staff) {
          next()
        } else {
          next({ name: SETTINGS_NOTIFY_TRACKING_MESSAGES_ROUTE })
        }
      },
      meta: {
        pageTitle: () => i18n.t('Tracking messages'),
        permissions: ['configure_tracking'],
        buttons: [btnHelpCenterMessagesV2],
      },
      children: [
        {
          name: SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_OVERVIEW_ROUTE,
          path: 'overview',
          component: () => import('@/app/settings/notify/views/messages-v2/TrackingMessagesOverview.vue'),
          meta: {
            pageTitle: () => i18n.t('Tracking messages'),
            permissions: ['configure_tracking'],
          },
        },
        {
          name: SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_SETTINGS_ROUTE,
          path: 'settings',
          component: () => import('@/app/settings/notify/views/messages-v2/TrackingMessagesSettings.vue'),
          meta: {
            pageTitle: () => i18n.t('Tracking messages'),
            permissions: ['configure_tracking'],
          },
        },
        {
          name: SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_EMAIL_ROUTE,
          path: ':notificationId/:countryCode/email',
          props: true,
          component: () => import('@/app/settings/notify/views/messages-v2/TrackingEmail.vue'),
          meta: {
            pageTitle: () => i18n.t('Tracking messages'),
            permissions: ['configure_tracking'],
            backLinkRoute: () => {
              return {
                title: i18n.t('settings.tracking.messages.return_to_overview'),
                to: { name: SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_OVERVIEW_ROUTE },
              }
            },
          },
        },
        {
          name: SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_SMS_ROUTE,
          path: ':notificationId/:countryCode/sms',
          props: true,
          component: () => import('@/app/settings/notify/views/messages-v2/TrackingSMS.vue'),
          meta: {
            pageTitle: () => i18n.t('Tracking messages'),
            permissions: ['configure_tracking'],
            backLinkRoute: () => {
              return {
                title: i18n.t('settings.tracking.messages.return_to_overview'),
                to: { name: SETTINGS_NOTIFY_TRACKING_MESSAGES_V2_OVERVIEW_ROUTE },
              }
            },
          },
        },
      ],
    },
  ],
}
